import actionsTypes from './types';

export default {
  throwGlobalError(error) {
    return {
      type: actionsTypes.THROW_GLOBAL_ERROR,
      payload: error,
    };
  },

  dismissGlobalError() {
    return { type: actionsTypes.DISMISS_GLOBAL_ERROR, payload: {} };
  },
};
